/**
 * dialog_manager from the last custom-cxd load.
 *
 * Portal `mappieBot` is programmatic-only (prompt tree). DFE must not seed
 * or read that slice. `loadCustomCxdReactFlow` writes the loaded manager
 * here; the adapter reads it so the module sidebar matches the version
 * without coupling the store. The version page mounts DFE only after that
 * fetch, so the adapter's first render sees this value.
 */

let lastLoadedDialogManager: string | undefined;

export function rememberLoadedCustomCxdDialogManager(
    dialogManager: string | undefined,
): void {
    lastLoadedDialogManager = dialogManager;
}

export function getLastLoadedCustomCxdDialogManager(): string | undefined {
    return lastLoadedDialogManager;
}
